"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Owner_1 = require("./_Owner");
var _Grants_1 = require("./_Grants");
exports.GetBucketAclOutput = {
    type: "structure",
    required: [],
    members: {
        Owner: {
            shape: _Owner_1._Owner
        },
        Grants: {
            shape: _Grants_1._Grants,
            locationName: "AccessControlList"
        }
    }
};
//# sourceMappingURL=GetBucketAclOutput.js.map